const JumpToAnchor = {
  init() {
    window.addEventListener(
      'load',
      () => {
        this.jumpToAnchor();
        window.addEventListener('hashchange', this.jumpToAnchor, false);
      },
      false
    );
  },

  jumpToAnchor() {
    const anchorId = document.URL.split('#')[1];
    if (!anchorId) {
      return;
    }

    const elements = document.querySelectorAll(`[id='${anchorId}']`) as NodeListOf<HTMLElement>;
    let visibleAnchorElement: HTMLElement | undefined;

    elements.forEach((element) => {
      if (element.offsetParent) {
        visibleAnchorElement = element;
      }
    });
    visibleAnchorElement?.scrollIntoView();
  }
};

JumpToAnchor.init();
